const performanceTranslations = {
  en: {
    title: "Performance Dashboard",
    topBarLabel: "Reformed Cleaning - Operations",
    loading: "Loading performance data...",
    errorLoading: "Unable to load performance data",
    noData: "No data for selected filters",
    view: "View",
    viewGraph: "Graph",
    viewList: "List",
    filters: {
      from: "From",
      to: "To",
      timeRange: "Time Range",
      week: "Week",
      month: "Month",
      multiMonth: "Multi-month",
      year: "Year",
      custom: "Custom",
      monthSpan: "Months",
      section: "Section",
      area: "Area",
      floor: "Floor",
      room: "Room",
      building: "Building",
      roomType: "Room",
      department: "Department",
      robot: "Robot",
      route: "Route",
      clear: "Clear",
      errorComplete: "Robot jobs with incidents",
      include: "Include",
      exclude: "Exclude",
      all: "All",
      north: "North",
      south: "South",
      operations: "Operations",
      cleaning: "Cleaning",
      hall: "Hall",
      warehouse: "Warehouse",
      routeA: "Route A",
      routeB: "Route B",
    },
    charts: {
      areaTitle: "Square Metres",
      areaSubtitle: "Cleaned area per month",
      areaSubtitleDay: "Cleaned area per day",
      areaSubtitleWeek: "Cleaned area per week",
      areaSubtitleMonth: "Cleaned area per month",
      tasksTitle: "Robot Tasks",
      tasksSubtitle: "Completed tasks per month",
      baseline: "Average Baseline",
      average: "Average",
      weekendNoRuns: "Weekend (no scheduled runs)",
      calculationInfoTitle: "Calculation details",
      baselineInfo: {
        title: "Baseline Information",
        description:
          "Baseline = 85 % of the total available cleaning floor area. Available cleaning area is 66.75% of blueprint area ((x * 0.75 * 0.89) minus inventory and things on floor).",
      },
      averageBaselineInfo: {
        title: "Average Baseline Information",
        description:
          "Average Baseline = average of all room baseline cleaning areas in the selected range. This excludes weekends.",
      },
      averageInfo: {
        title: "Average Information",
        description:
          "Average = total area cleaned / (total number of days - weekend days).",
      },
      toggleInfo: {
        title: "Toggle Information",
        description:
          "Toggle to include or exclude days with no runs in the average calculation (weekends are always excluded). Excluding days with no runs will give a more accurate representation of performance on days when the robot is actually running.",
      },
    },
    overview: {
      areaTitle: "Square metres realized",
      areaPlanLabel: "Square metres possible",
      areaMissingLabel: "Missing",
      completeJobs: "Complete Jobs",
      completeWithErrorJobs: "Completed with Error",
      tasksTitle: "Robot tasks realized",
      tasksPlanLabel: "Robot tasks planned",
      tasksMissingLabel: "Outstanding",
      of: "of",
      jobsCompleted: "Jobs completed",
      jobsOutstanding: "Jobs outstanding",
    },
    top10: {
      title: "Top 10 Performers",
      chip: "Robots",
      subtitle: "Ranked by target achievement",
    },
    toggles: {
      includeDaysNotRunInAverage: "Include days not run in average",
    },
    months: [
      "jan",
      "feb",
      "mar",
      "apr",
      "may",
      "jun",
      "jul",
      "aug",
      "sep",
      "oct",
      "nov",
      "dec",
    ],
  },
  da: {
    title: "Performance Dashboard",
    topBarLabel: "Reformed Cleaning",
    loading: "Indlæser performance-data...",
    errorLoading: "Kunne ikke indlaese performance-data",
    noData: "Ingen data for valgte filtre",
    view: "Visning",
    viewGraph: "Graf",
    viewList: "Liste",
    filters: {
      from: "Fra",
      to: "Til",
      timeRange: "Tidsperiode",
      week: "Uge",
      month: "Måned",
      multiMonth: "Flere måneder",
      year: "År",
      custom: "Brugerdefineret",
      monthSpan: "Måneder",
      section: "Sektion",
      area: "Område",
      floor: "Etage",
      room: "Rum",
      building: "Bygning",
      roomType: "Rum",
      department: "Afdeling",
      robot: "Robot",
      route: "Rute",
      clear: "Nulstil",
      errorComplete: "Robotopgaver med hændelser",
      include: "Inkluder",
      exclude: "Ekskluder",
      all: "Alle",
      north: "Nord",
      south: "Syd",
      operations: "Drift",
      cleaning: "Rengøring",
      hall: "Hal",
      warehouse: "Lager",
      routeA: "Rute A",
      routeB: "Rute B",
    },
    charts: {
      areaTitle: "Kvadratmeter",
      areaSubtitle: "Rengjort areal pr. måned",
      areaSubtitleDay: "Rengjort areal pr. dag",
      areaSubtitleWeek: "Rengjort areal pr. uge",
      areaSubtitleMonth: "Rengjort areal pr. måned",
      tasksTitle: "Robotopgaver",
      tasksSubtitle: "Gennemførte opgaver pr. måned",
      baseline: "Gennemsnit Baseline",
      average: "Gennemsnit",
      weekendNoRuns: "Weekend (ingen planlagte kørsel)",
      calculationInfoTitle: "Beregning",
      baselineInfo: {
        title: "Basislinje",
        description:
          "Basislinje = 85 % af det samlede tilgængelige rengøringsgulvareal. Det tilgængelige rengøringsareal er 66,75 % af blueprint-arealet ((x * 0.75 * 0.89) minus inventar og ting på gulvet).",
      },
      averageBaselineInfo: {
        title: "Gennemsnit Baseline",
        description:
          "Gennemsnit Baseline = gennemsnit af alle rum baseline rengøringsarealer i den valgte periode. Dette udelukker weekender.",
      },
      averageInfo: {
        title: "Gennemsnit",
        description:
          "Gennemsnit = samlet rengjort areal / (samlet antal dage – weekender).",
      },
      toggleInfo: {
        title: "Toggle Info",
        description:
          "Inkluder eller udeluk dage uden kørsel i gennemsnitsberegningen (weekender udelukkes altid). Udelukkelse af dage uden kørsel giver en mere nøjagtig repræsentation af ydeevnen på de dage, hvor robotten faktisk kører.",
      },
    },
    overview: {
      areaTitle: "Kvadratmeter realiseret",
      areaPlanLabel: "Kvadratmeter muligt",
      areaMissingLabel: "Manglende",
      completeJobs: "Fuldforte jobs",
      completeWithErrorJobs: "Fuldforte med fejl",
      tasksTitle: "Robotopgaver realiseret",
      tasksPlanLabel: "Robotopgaver planlagt",
      tasksMissingLabel: "Udestaende",
      of: "af",
      jobsCompleted: "Fuldforte jobs",
      jobsOutstanding: "Udestaende jobs",
    },
    top10: {
      title: "Top 10 Performere",
      chip: "Robotter",
      subtitle: "Rangeret efter målopfyldelse",
    },
    toggles: {
      includeDaysNotRunInAverage: "Inkluder dage uden kørsel i gennemsnit",
    },
    months: [
      "jan",
      "feb",
      "mar",
      "apr",
      "maj",
      "jun",
      "jul",
      "aug",
      "sep",
      "okt",
      "nov",
      "dec",
    ],
  },
};

export default performanceTranslations;
